import { type CurrencyName } from '@webapp/core/entities/external/Currency'
import { type AssignedCreditCardConstructor } from '@webapp/modules/expense/entities/AssignedCreditCard'
import { type AssignedCreditCardApiModel } from '../api-models/AssignedCreditCardApiModel'

export const mapAssignedCreditCardApiModel = (
  apiModel: AssignedCreditCardApiModel
): AssignedCreditCardConstructor => ({
  id: apiModel.id,
  name: apiModel.name,
  number: apiModel.number,
  type: apiModel.type,
  currency: {
    id: apiModel.currency.id,
    name: apiModel.currency.name as CurrencyName,
    rate: parseFloat(apiModel.currency.rate),
    base: apiModel.currency.base,
  },
})
